export const GET_GEOLOCATION = "GET_GEOLOCATION";
export const SAVE_GEOLOCATION_FROM_SESSION_STORAGE =
  "SAVE_GEOLOCATION_FROM_SESSION_STORAGE";
export const GET_GEOLOCATION_PENDING = "GET_GEOLOCATION_PENDING";
export const GET_GEOLOCATION_REJECTED = "GET_GEOLOCATION_REJECTED";
export const GET_GEOLOCATION_FULFILLED = "GET_GEOLOCATION_FULFILLED";
